import { NgModule } from '@angular/core';
import { HighlightOnActiveDirective } from '../directives/highlight-on-active.directive';
import { OnlyNumberDirective } from '../directives/only-number.directive';
import { HasPermissionDirective } from '../directives/has-permission.directive';
import { DisableWithoutPermissionDirective } from '../directives/disable-without-permission.directive';

@NgModule({
  declarations: [HighlightOnActiveDirective, OnlyNumberDirective, HasPermissionDirective, DisableWithoutPermissionDirective],
  exports: [HighlightOnActiveDirective, OnlyNumberDirective, HasPermissionDirective, DisableWithoutPermissionDirective]
})

export class SharedDirectivesModule {}
